module.exports = __webpack_public_path__ + "9b2683410e440e48abb51e9799230257.png";